export const AppShot = ({ src, alt, label, className = "", eager = false }) => (
  <figure className={`app-shot ${className}`.trim()}>
    <div className="app-shot__bezel">
      <div className="app-shot__speaker" aria-hidden="true" />
      <div className="app-shot__viewport">
        <img
          src={src}
          alt={alt}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : "auto"}
          width="720"
          height="1604"
        />
      </div>
    </div>
    {label ? <figcaption>{label}</figcaption> : null}
  </figure>
);
